export default __webpack_public_path__ + "static/media/summer-cherries.4976dc4c.png";